import i18n from "config/i18next";

i18n.addResources("es", "presettlements", {
  presettlementsTitle: "Preliquidaciones",
  presettlement: "preliquidación",
  presettlements: "preliquidaciones",
  sendToAccountingTitle: "Enviá las preliquidaciones a contabilidad",
  sendToAccountingMessage: "¿Deseás enviar {{quantity}} a contabilidad?",
  send: "Sí, enviar",
  sendToAccounting: "Enviar a contabilidad",
  approveInvoices: "Aprobar facturas",
  noInvoicesTitle: "No hay facturas",
  noInvoicesMessage: "Esperá a que hayan más facturas en aprobación",
  concurrencyTitle: "Error en la modificación",
  concurrencyMessage:
    "La preliquidación ya está siendo modificada. Intentalo nuevamente en unos minutos",
  successSendAccountingTitle: "Envío exitoso",
  successSendAccountingBody:
    "Las preliquidaciones se enviaron a contabilidad correctamente.",
  successSendAccountingBodySingular:
    "La preliquidación se envió a contabilidad correctamente.",
  successSendAccountingBodyNonAR:
    "Las preliquidaciones se enviaron a contabilidad correctamente.",
  successSendAccountingBodySingularNonAR:
    "La preliquidación se envió a contabilidad correctamente.",
  warningSendAccountingTitleSingular:
    "No pudimos validar {{count}} preliquidación",
  warningSendAccountingTitlePlural:
    "No pudimos validar {{count}} preliquidaciones",
  warningSendAccountingBodySingular:
    'Verificá con el filtro de estado aquella en "No validada por E.G."',
  warningSendAccountingBodyPlural:
    'Verificá con el filtro de estado aquellas en "No validada por E.G."',
});
